import { Headline, Text } from '@oneaudi/unified-web-alpha-components';
import { useCallback, useEffect } from 'react';
import { useAppState } from '~/app/contexts/app-context';
import { useI18n } from '~/app/i18n/i18n';
import { DialogProps } from '~/app/pages/summary/dialogs/dialog-props';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { EventAction } from '~/app/tracking/feld-m-types';
import { Dialog } from '~/components/dialog';

export function FinancingDisclaimerDialog({ open, onClose }: DialogProps) {
	useEffect(() => {
		open &&
			appTrackingService.viewChangeEvent({
				eventName: 'configurator - financing disclaimer layer',
				componentName: 'configurator-financing-disclaimer-layer',
			});
	}, [open]);

	const trackDialogClose = useCallback(() => {
		appTrackingService.summaryClickEvent({
			eventAction: EventAction.InternalLink,
			eventName: `configurator - click to close layer`,
			componentName: 'configurator-financing-disclaimer-layer',
			elementName: '',
		});

		appTrackingService.viewChangeEvent({
			eventName: 'generic',
		});
	}, []);

	return (
		<>
			{' '}
			<Dialog
				open={open}
				onCloseButtonClick={() => {
					trackDialogClose();
					onClose();
				}}>
				<DisclaimerDialog onClose={onClose} open={open} />
			</Dialog>
		</>
	);
}

const DisclaimerDialog = ({}: DialogProps) => {
	const { financingData } = useAppState();
	const { i18n } = useI18n();
	const disclaimers = financingData?.financing?.disclaimers;
	const currentProduct = financingData?.financing?.meta?.externalRequestOptions?.Product?.['@ID'] as string;

	const getTitle = (product: string) => {
		switch (product) {
			case 'PL':
				return i18n('ngc.actions.leaseDisclaimer');
			case 'CA':
				return i18n('ngc.actions.cashDisclaimer');
			case 'CC':
				return i18n('ngc.actions.financeDisclaimer');
			default:
				return i18n('ngc.actions.financeDisclaimer');
		}
	};

	return (
		<>
			<Headline tag={'label'} variant={{ type: 'headline', order: '3', weight: 'bold' }}>
				{getTitle(currentProduct)}
			</Headline>
			<ul>
				{disclaimers?.map((disclaimer, index) => (
					<li key={index}>
						<Text>{disclaimer.text}</Text>
					</li>
				))}
			</ul>
		</>
	);
};
